import {auth} from './auth';
import {news} from './content/news';
import {qna} from './content/qna';
import {home} from './content/home';
import {summaries} from './content/summaries';
import {dashboard} from './dashboard';

export const services = {auth, news, home, qna, summaries, dashboard};
